import Icon from '../../components/Icon.vue'

Icon.register({"regular/caret-square-up":{"width":448,"height":512,"paths":[{"d":"M322.9 304H125.1C114.4 304 109 291 116.6 283.5L215.5 185.2C220.2 180.5 227.7 180.5 232.4 185.2L331.3 283.5C339 291 333.6 304 322.9 304zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM400 426V86C400 82.7 397.3 80 394 80H54C50.7 80 48 82.7 48 86V426C48 429.3 50.7 432 54 432H394C397.3 432 400 429.3 400 426z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/caret-square-up.js
// module id = bpyR
// module chunks = 0